"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseModule = /** @class */ (function () {
    function BaseModule(adapter, option) {
        this.adapter = adapter;
        this.option = option;
    }
    BaseModule.prototype.setProps = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
    };
    BaseModule.prototype.replaceProps = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
    };
    BaseModule.prototype.destructor = function () { };
    return BaseModule;
}());
exports.BaseModule = BaseModule;
function buildMapFromStringMap(stringMap) {
    return new Map(Object.keys(stringMap).map(function (key) { return [key, stringMap[key]]; }));
}
var ModuleManager = /** @class */ (function () {
    function ModuleManager(adapter, modulesMap) {
        this.modulesMap = new Map();
        this.cache = {};
        this.adapter = adapter;
        this.modulesMap = buildMapFromStringMap(modulesMap);
    }
    ModuleManager.prototype.install = function () {
        var _this = this;
        this.modulesMap.forEach(function (moduleMap, name) {
            _this.cache[name] = new moduleMap.Ctor(_this.adapter, moduleMap.option);
        });
    };
    ModuleManager.prototype.add = function (name, override) {
        if (override === void 0) { override = false; }
        if (!override && this.cache[name])
            return;
        var moduleMap = this.modulesMap.get(name);
        if (!moduleMap)
            return;
        var module = this.cache[name];
        if (module) {
            module.destructor();
            this.cache[name] = null;
        }
        this.cache[name] = new moduleMap.Ctor(this.adapter, moduleMap.option);
    };
    ModuleManager.prototype.remove = function (name) {
        var module = this.cache[name];
        if (module) {
            module.destructor();
            this.cache[name] = null;
        }
    };
    ModuleManager.prototype.uninstall = function () {
        var _this = this;
        Object.keys(this.cache).forEach(function (name) {
            var module = _this.cache[name];
            module && module.destructor();
            _this.cache[name] = null;
        });
    };
    return ModuleManager;
}());
exports.ModuleManager = ModuleManager;
//# sourceMappingURL=module.js.map